import React from 'react';
import { Box } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const DropZone = ({ id, label, color, hoverColor, icon: CustomIcon }) => {
    const { isOver, setNodeRef } = useDroppable({
        id: id
    });

    // Determine which icon to show: Custom -> Fridge (Check) -> Default (Cancel)
    let IconComponent = CustomIcon;
    if (!IconComponent) {
        IconComponent = id === 'fridge' ? CheckCircleIcon : CancelIcon;
    }

    return (
        <Box
            ref={setNodeRef}
            sx={{
                width: '100%',
                minHeight: 150,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 4,
                border: '3px dashed',
                borderColor: isOver ? hoverColor : 'rgba(255, 255, 255, 0.5)',
                bgcolor: isOver ? `${hoverColor}20` : color,
                transition: 'all 0.3s ease',
                transform: isOver ? 'scale(1.05)' : 'scale(1)',
                boxShadow: isOver ? 8 : 3,
                cursor: 'pointer',
                animation: isOver ? 'pulse 1s infinite' : 'none',
                '@keyframes pulse': {
                    '0%, 100%': {
                        opacity: 1,
                    },
                    '50%': {
                        opacity: 0.8,
                    },
                },
            }}
        >
            <IconComponent 
                sx={{ 
                    fontSize: 80,
                    color: isOver ? hoverColor : 'white',
                    transition: 'all 0.3s ease'
                }}
            />
        </Box>
    );
};

export default DropZone;
